import { Typography, Box } from '@mui/material';
import React, { useContext, useState, useEffect } from 'react';
import Content from '../components/Layout/Content';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import SearchBar from '../components/SearchBar/Search';
import ApplicationContext from '../context/applicationContext';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import PaginationComponent from '../components/paginationComponent/ServerSidePaginationComponent';
import {
  FETCH_ALL_EOB_QUERY,
  DEFAULT_FETCH_EOB_ID_QUERY,
} from '../services/ClaimsQueries/ClaimsService';
import {
  ClaimsStatusFilteredData,
  claimTypeFilterMenuItems,
  dateFilterMenuItems,
  DEFAULT_NULL_REPLACEMENT,
  NUMBER_OF_ROWS_PER_PAGE,
  CLAIMS,
  CLAIMS_STATUS_LIST,
} from '../shared/constants';
import {
  handleTimeFilter,
  handleStatusFilter,
  searchDataByKey,
  getIconFromSubItemsArray,
  formatClaimsData,
  formatDateInMMDDYYYYWithComma,
  calculateDateFilterTimeStamp,
  getStatusFilterParamList,
  handleclaimsTypeFilter,
} from '../shared/helper';
import { ServiceFlyout } from '../components/ServiceFlyout/ServiceFlyout';
import patientPortion from '../assests/patientPortion.svg';
import insurerPortion from '../assests/insurerPortion.svg';
import ClaimsCostDashboard from '../components/claims/ClaimsCostDashboard.js';
import { useLazyQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import NotFound from '../components/NotFound/NotFoundPage';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import Card from '@mui/material/Card';
import {
  CLAIMS_DATA,
  CLAIMS_DATA_TABLE_HEADING as tableHeading,
  CLAIMS_DATA_BREADCRUMBDATA as breadcrumbData,
  IMAGE_ALTERNATE_TEXT,
} from '../shared/Strings';

const boxContainer = {
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  top: 40,
  flex: 1,
};
const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};

export const Claims = () => {
  const [searchValue, setSearchValue] = useState('');
  const [recordsData, setRecordedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [offset, setOffset] = useState(0);
  const [timeFilter, setTimeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [claimType, setClaimType] = useState(claimTypeFilterMenuItems[0].value);
  const [openFlyout, setOpenFlyout] = useState(false);
  const { menuItems } = useContext(ApplicationContext);
  const [selectedTableId, setSelectedTableId] = useState(null);
  const [detailsData, setDetailsData] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const closeFlyout = () => {
    setOpenFlyout(false);
  };

   const handleChangeFilter = () => {
     setOffset(0);
   };

  // const allClaims = useQuery(FETCH_ALL_EOB_QUERY, {
  //   variables: {
  //     eobType: 'ALL',
  //     timePeriod: 'ALL',
  //     sourceUrl: '',
  //     count: '10',
  //     offset: 0,
  //     dateFilter: 0,
  //     statusFilter: '',
  //     searchFilter: '',
  //   },
  //   onError: err => {
  //     enqueueSnackbar(CLAIMS_DATA.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
  //       variant: 'error',
  //     });
  //   },
  // });

  const [fetchAllClaims, fetchAllClaimsCall] = useLazyQuery(
    FETCH_ALL_EOB_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(CLAIMS_DATA.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        let result = [...res.fetchAllEob.eobList];
        let data = formatClaimsData(result);
        setRecordedData(data);
        setFilteredData(data);
        setTotalCount(res.fetchAllEob.count);
      },
    }
  );

  const [fetchEobById, fetchEobByIdCall] = useLazyQuery(
    DEFAULT_FETCH_EOB_ID_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(CLAIMS_DATA.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        showFlyout(res.fetchEobById);
      },
    }
  );

  useEffect(() => {
    fetchAllClaims({
      variables: {
        eobType: 'ALL',
        timePeriod: 'ALL',
        sourceUrl: '',
        count: NUMBER_OF_ROWS_PER_PAGE.toString(),
        offset: offset,
        dateFilter: calculateDateFilterTimeStamp(timeFilter) || 0,
        statusFilter: getStatusFilterParamList(statusFilter, ClaimsStatusFilteredData, CLAIMS_STATUS_LIST),
        searchFilter: searchValue,
      },
    });
  }, [offset, timeFilter, statusFilter, searchValue]);  

  const onPageClick = pageNumber => {
    setOffset((pageNumber - 1) * 10);
  };

  const onSearch = text => {
    setSearchValue(text);
    offset !== 0 && setOffset(0);
  };

  const claimsTypeFilterOptions = {
    options: claimTypeFilterMenuItems,
    value: claimType,
    changeHandler: ev => {
      setClaimType(ev.target.value);
      handleChangeFilter();
    },
  };

  const statusFilterOptions = {
    options: ClaimsStatusFilteredData,
    value: statusFilter,
    changeHandler: ev => {
      setStatusFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  const dateFilterOptions = {
    options: dateFilterMenuItems,
    value: timeFilter,
    changeHandler: ev => {
      setTimeFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  const detailsLoading = fetchEobByIdCall.loading;


  const showFlyout = result => {
    const tableRowInfo = recordsData.find(obj => obj.id === selectedTableId);
    const modalData = [
      {
        column_name: CLAIMS_DATA.MODAL_DATA.STATUS,
        value: tableRowInfo.status,
      },
      {
        column_name: CLAIMS_DATA.MODAL_DATA.PROVIDER,
        value: tableRowInfo.provider,
      },
      {
        column_name: CLAIMS_DATA.MODAL_DATA.CLAIM_TYPE,
        value: tableRowInfo.claimTypeLabel,
      },

      {
        column_name: CLAIMS_DATA.MODAL_DATA.CTREATED_ON,
        value: tableRowInfo.recordedOn,
      },
      {
        column_name: CLAIMS_DATA.MODAL_DATA.CLAIM_AMOUNT,
        value: tableRowInfo.claimAmount,
      },
      {
        column_name: CLAIMS_DATA.MODAL_DATA.START_DATE,
        value:
          (result.claimFromDate &&
            formatDateInMMDDYYYYWithComma(result.claimFromDate)) ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: CLAIMS_DATA.MODAL_DATA.END_DATE,
        value:
          (result.claimToDate &&
            formatDateInMMDDYYYYWithComma(result.claimToDate)) ||
          DEFAULT_NULL_REPLACEMENT,
      },
    ];
    setDetailsData(modalData);
    setOpenFlyout(true);
  };

  const viewDetailsHandler = id => {
    setSelectedTableId(id);
    const tableRowInfo = recordsData.find(obj => obj.id === id);
    setModalTitle(tableRowInfo.claimNumber);
    fetchEobById({
      variables: {
        eobId: id,
      },
    });
  };

  const CardCost = () => {
    return (
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: 568,
          p: '20px',
          mt: '40px',
          borderRadius: '8px',
          boxShadow: 2,
          justifyContent: 'space-around',
          mr: '12px',
        }}>
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <img
            src={patientPortion}
            alt={IMAGE_ALTERNATE_TEXT.PATIENT_IMG}
            sx={{ mr: '8px' }}
          />
          <Typography variant="h5" sx={{ ml: '12px' }}>
            {CLAIMS.CARD_TITLE_PATIENT}
          </Typography>
          <Typography sx={{ ml: '12px', pr: '5px' }}>
            {/* {formatCost(eobType.patientAmount)} */}
            $665567
          </Typography>
        </Box>
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <img src={insurerPortion} alt="insurenaceimg" />
          <Typography variant="h5" sx={{ ml: '12px' }}>
            {CLAIMS.CARD_TITLE_INSURER}
          </Typography>
          <Typography sx={{ ml: '12px' }}>
            {/* {formatCost(eobType.paymentByMedicare)} */}
            $567887
          </Typography>
        </Box>
      </Card>
    );
  };

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="h1">{CLAIMS.TITLE}</Typography>
      {/* <CardCost /> */}
      {/* <ClaimsCostDashboard /> */}
      <Box sx={boxContainer}>
        <SearchBar
          sx={{
            width: '50%',
            minWidth: '250px',
            maxWidth: '500px',
            marginTop: '8px',
          }}
          onSearch={onSearch}
          placeholder={CLAIMS_DATA.SEARCH_PLACEHOLDER_TEXT}
        />
        <FilterDropDown {...dateFilterOptions} filterType="Date:" />
        <FilterDropDown {...claimsTypeFilterOptions} filterType="Claims:" />
        <FilterDropDown {...statusFilterOptions} filterType="Status:" />
      </Box>
      <Box sx={table}>
        {!fetchAllClaimsCall.loading && !filteredData.length ? (
          <NotFound title={CLAIMS_DATA.TITLE_TEXT} />
        ) : (
          <>
            <ReusableTable
              tableHeading={tableHeading}
              data={filteredData}
              viewDetailsHandler={viewDetailsHandler}
            />
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginTop: 18,
              }}>
              {totalCount > NUMBER_OF_ROWS_PER_PAGE && (
                <PaginationComponent
                  numberOfRowsPerPage={NUMBER_OF_ROWS_PER_PAGE}
                  count={totalCount}
                  onPageClick={onPageClick}
                  page={offset / 10}
                />
              )}
            </div>
          </>
        )}
      </Box>
      <ServiceFlyout
        isOpen={openFlyout}
        handleClose={closeFlyout}
        data={detailsData}
        icon={
          menuItems
            ? getIconFromSubItemsArray(menuItems?.Financial?.subItems, 'Claims')
            : null
        }
        category={CLAIMS_DATA.TITLE_TEXT}
        title={modalTitle}></ServiceFlyout>
      <SimpleBackdrop open={fetchAllClaimsCall.loading || detailsLoading} />
    </Content>
  );
};
